import React from "react";
import App, { createAppRouter } from "./App";
import "./index.css";

import { createRoot } from "react-dom/client";
import { PostHogProvider } from "~/shared/components/PostHogProvider";

async function enableMockServiceWorker() {
  if (import.meta.env.MODE !== "development" || !import.meta.env.VITE_ENABLE_MOCKS) return;

  const { worker } = await import("./mocks/browser");

  return worker.start({
    onUnhandledRequest: "bypass",
  });
}

const container = document.getElementById("root");
const root = createRoot(container!);

enableMockServiceWorker()
  .catch((e) => {
    // eslint-disable-next-line no-console
    console.error("Failed to start mock service worker");
  })
  .finally(() => {
    const router = createAppRouter();

    root.render(
      <React.StrictMode>
        <PostHogProvider>
          <App router={router} />
        </PostHogProvider>
      </React.StrictMode>,
    );
  });
